import script from "./contact-page.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-page.vue?vue&type=script&setup=true&lang=js"

import "./contact-page.vue?vue&type=style&index=0&id=a9e8a3e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9e8a3e4"]])

export default __exports__